import React from 'react';
import {
  Box,
  TextField,
  Button,
  Stack,
  FormControlLabel,
  Switch,
  CircularProgress,
  InputAdornment,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { buildVatSavePayload } from '../../utils/settingsForm';
import SettingsSectionCard from './SettingsSectionCard';

function VatSettingsSection({
  form,
  setField,
  onSave,
  onReset,
  loading,
  saving,
  error,
  success,
  setSuccess,
}) {
  const { t } = useTranslation();

  const handleSave = () => onSave(buildVatSavePayload(form));

  if (loading) {
    return <Box display="flex" justifyContent="center" py={4}><CircularProgress size={24} /></Box>;
  }

  return (
    <SettingsSectionCard
      title={t('settings.sections.vat')}
      description={t('settings.sections.vatHelp')}
      error={error}
      success={success}
      successMessage={t('settings.saved')}
      onCloseSuccess={() => setSuccess(false)}
    >
      <Stack spacing={2.5}>
        <TextField
          label={t('settings.vatPercentage')}
          value={form.vatPercentage}
          onChange={(e) => setField('vatPercentage', e.target.value)}
          type="number"
          inputProps={{ min: 0, max: 100, step: 0.01 }}
          InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
          size="small"
          sx={{ maxWidth: 220 }}
        />
        <FormControlLabel
          control={
            <Switch
              checked={form.pricesIncludeVat}
              onChange={(e) => setField('pricesIncludeVat', e.target.checked)}
            />
          }
          label={t('settings.pricesIncludeVat')}
        />
        <Stack direction="row" spacing={1}>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? t('common.saving') : t('common.save')}
          </Button>
          <Button variant="outlined" onClick={onReset} disabled={saving}>{t('common.reset')}</Button>
        </Stack>
      </Stack>
    </SettingsSectionCard>
  );
}

export default VatSettingsSection;
